import { createFileRoute } from "@tanstack/react-router"
import { zodValidator } from "@tanstack/zod-adapter"

import PermissionContentWrapper from "@/components/PermissionWrapper/PermissionContentWrapper"
import { PermissionActionType } from "@/constants/permissions"
import { GoodsReceiptSortField, SortingOrder } from "@/graphql/codegen/graphql"
import { CostBreakdownContainer } from "@/screens/Procurement/CostBreakdown/components"
import { createCostBreakdownSearchSchema } from "@/screens/Procurement/CostBreakdown/schemas"
import { uomLoader } from "@/screens/WarehouseReceiving/loaders"

export const Route = createFileRoute("/app/procurement/_layout/cost-breakdown")({
  validateSearch: zodValidator(createCostBreakdownSearchSchema(GoodsReceiptSortField.CheckedInOn, SortingOrder.Desc)),
  loader: uomLoader,
  component: () => (
    <PermissionContentWrapper permissions={[PermissionActionType.COST_BREAKDOWN_VIEW]}>
      <CostBreakdownContainer />
    </PermissionContentWrapper>
  ),
})
